import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M9.318 13.632A3.223 3.223 0 0 1 6.1 10.414a3.223 3.223 0 0 1 3.22-3.219 3.223 3.223 0 0 1 3.218 3.22 3.223 3.223 0 0 1-3.219 3.217M16.353 15.228a2.527 2.527 0 0 1-2.524-2.525 2.527 2.527 0 0 1 2.524-2.525 2.53 2.53 0 0 1 2.525 2.525 2.53 2.53 0 0 1-2.525 2.525"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.96 12c0 5.535 4.505 10.039 10.04 10.039s10.039-4.504 10.039-10.04c0-5.534-4.504-10.038-10.04-10.038C6.466 1.96 1.962 6.465 1.962 12m1.5 0c0-4.708 3.832-8.54 8.54-8.54s8.539 3.832 8.539 8.54a8.5 8.5 0 0 1-1.687 5.09c-.745-.267-1.614-.402-2.588-.402-3.614 0-5.144 1.872-5.372 3.649l-.01.129a9 9 0 0 1-.988-.19v-.015l.009-.078c.172-1.336.99-2.815 2.689-3.699.205-.107.24-.393.04-.51-.749-.438-1.814-.773-3.322-.773-2.41 0-3.687.865-4.346 1.633A8.5 8.5 0 0 1 3.461 12"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersFilled);
export default ForwardRef;
